import { getExtensionId } from '../get-extension-id';

export const syncAuthWithExtension = (action: string, tokens?: any) => {
  if (!window.chrome?.runtime?.sendMessage) {
    console.log("[AuthSync] Chrome runtime not available");
    return;
  }

  const extensionId = getExtensionId();
  if (!extensionId) {
    console.error("[AuthSync] EXTENSION_ID not configured");
    return;
  }

  const payload = {
    type: action,
    payload: tokens,
  };

  try {
    chrome.runtime.sendMessage(extensionId, payload, (response) => {
      if (chrome.runtime.lastError) {
        console.log(
          "[AuthSync] Extension not installed or not responding:",
          chrome.runtime.lastError.message
        );
      } else {
        console.log("[AuthSync] Extension sync response:", action, response);
      }
    });
  } catch (err) {
    console.error("[AuthSync] Error:", err);
  }
};

/**
 * Синхронізує авторизацію з розширенням при завантаженні сторінки
 * Викликати в App.tsx або AuthProvider після перевірки що користувач залогінений
 */
export const syncAuthOnLoad = (
  accessToken: string,
  refreshToken: string,
  user: any
) => {
  if (!accessToken || !user) return;

  console.log("[AuthSync] Syncing auth on page load...");

  syncAuthWithExtension("AUTH_LOGIN", {
    accessToken,
    refreshToken,
    user,
  });
};
